import {
    getConfig,
    getRawRemoteConfig,
} from '@superbet-group/web.lib.config';
import {
    Country,
    Locale,
} from '@superbet-group/web.types';

import { shellLocalConfig } from './localConfig';
import { ShellLocalConfig } from './localConfigTypes';
import { getShellRemoteConfig } from './remoteConfig';
import {
    ShellRemoteConfig,
    ShellRemoteConfigDto,
} from './remoteConfigTypes';

export type ShellConfig = {
    localConfig: ShellLocalConfig;
    remoteConfig: ShellRemoteConfig;
    locale: Locale;
    country: Country;
};

let configuration: ShellConfig;

export function getShellConfig() : ShellConfig {
    if (!configuration) {
        configuration = {
            localConfig: shellLocalConfig,
            remoteConfig: getShellRemoteConfig(getRawRemoteConfig() as ShellRemoteConfigDto),
            locale: getConfig().appLocale.locale,
            country: getConfig().countrySpecific.country,
        };
    }

    return configuration;
}

export function setShellConfig(overrideConfig: ShellConfig) {
    configuration = overrideConfig;
}
